import React, { useState } from "react";
import { Box, Typography, TextField, Button, Card, CardContent } from "@mui/material";
import { styled, keyframes } from "@mui/system";
import { sendEmailWithSES } from "../../services/sesService";

// Animación de fade-in
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Contenedor principal estilizado
const ContactContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
  padding: theme.spacing(20, 3, 5),
  backgroundColor: theme.palette.background.default,
  animation: `${fadeIn} 1s ease-in-out`,
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(15, 2, 3),
  },
}));

// Card estilizado
const ContactCard = styled(Card)(({ theme }) => ({
  maxWidth: "800px",
  width: "100%",
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
  padding: theme.spacing(4),
  animation: `${fadeIn} 1.2s ease-in-out`,
  overflow: "auto",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
}));

const ContactComponent = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      await sendEmailWithSES({
        from: process.env.REACT_APP_SES_FROM_EMAIL,
        to: process.env.REACT_APP_SES_TO_EMAIL, // Enviar el correo a tu dirección de contacto
        subject: `Nuevo mensaje de ${formData.name}`,
        message: `Nombre: ${formData.name}\nEmail: ${formData.email}\nMensaje: ${formData.message}`,
      });
      setSuccess("Mensaje enviado con éxito.");
      setFormData({ name: "", email: "", message: "" }); // Limpiar el formulario
    } catch (error) {
      setError(`Error enviando el correo: ${error.message}`);
    }
  };

  return (
    <ContactContainer>
      <ContactCard>
        <CardContent>
          <Typography variant="h4" gutterBottom sx={{ textAlign: "center", color: "text.secondary" }}>
            Contáctame
          </Typography>
          <form onSubmit={handleSubmit}>
            <TextField
              label="Nombre"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Mensaje"
              name="message"
              value={formData.message}
              onChange={handleChange}
              fullWidth
              margin="normal"
              multiline
              rows={4}
              required
            />
            {error && (
              <Typography variant="body2" color="error" sx={{ marginTop: 2 }}>
                {error}
              </Typography>
            )}
            {success && (
              <Typography variant="body2" color="success.main" sx={{ marginTop: 2 }}>
                {success}
              </Typography>
            )}
            <Button type="submit" variant="contained" color="primary" sx={{ marginTop: 2 }}>
              Enviar
            </Button>
          </form>
        </CardContent>
      </ContactCard>
    </ContactContainer>
  );
};

export default ContactComponent;